import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const SHOPSCUSTOMMAPBLOCK_LEGACY_FIELD_ORDER = [
  "shops",
  { type: 'separator' },
  "image",
  "background_color",
  "image_width",
  "image_height",
  "initial_zoom",
  "max_zoom",
  "initial_position_x",
  "initial_position_y"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  shopsCustomMapBlockDescriptor: _generatedShopsCustomMapBlockDescriptor,
  shopsCustomMapBlockBlocDefinition,
  shopsCustomMapBlockDashboardLayout,
  shopsCustomMapBlockConfig,
  shopsCustomMapBlockResolveConfig,
  shopsCustomMapBlockProperties,
} = doodBlockConfig(
  {
    name: "Shops custom map",
    componentType: 'ShopsCustomMapBlockComponent',
    category: 'catalog',
    description: "Shops custom map.",
    keywords: [],
    hideFromPicker: true,
    sharedFields: {}
  },

  () => ({
    shops: propertyValue({
      type: 'json_editor',
      value: '',
      options: {
        label: "pages.blocks.shops-custom-map.shops.label",
        help: "pages.blocks.shops-custom-map.shops.help",
      }
    }),
    image: propertyValue({
      type: 'image',
      value: '',
      options: {
        label: "pages.blocks.shops-custom-map.image.label",
        help: "pages.blocks.shops-custom-map.image.help",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"hex","value":"#FFFFFF"},
      options: {
        label: "pages.blocks.shops-custom-map.background-color.label",
      }
    }),
    image_width: propertyValue({
      type: 'text',
      value: '2100',
      options: {
        label: "pages.blocks.shops-custom-map.image-width.label",
        help: "pages.blocks.shops-custom-map.image-width.help",
      }
    }),
    image_height: propertyValue({
      type: 'text',
      value: '2100',
      options: {
        label: "pages.blocks.shops-custom-map.image-height.label",
        help: "pages.blocks.shops-custom-map.image-height.help",
      }
    }),
    initial_zoom: propertyValue({
      type: 'select',
      value: "cover",
      options: {
        label: "pages.blocks.shops-custom-map.initial-zoom.label",
        choices: [
          {
            value: "contain",
            label: "pages.blocks.shops-custom-map.initial-zoom.options.contain",
          },
          {
            value: "cover",
            label: "pages.blocks.shops-custom-map.initial-zoom.options.cover",
          }
        ]
      }
    }),
    max_zoom: propertyValue({
      type: 'text',
      value: '1.5',
      options: {
        label: "pages.blocks.shops-custom-map.max-zoom.label",
        help: "pages.blocks.shops-custom-map.max-zoom.help",
      }
    }),
    initial_position_x: propertyValue({
      type: 'text',
      value: '0.6',
      options: {
        label: "pages.blocks.shops-custom-map.initial-position-x.label",
        help: "pages.blocks.shops-custom-map.initial-position-x.help",
      }
    }),
    initial_position_y: propertyValue({
      type: 'text',
      value: '0.08',
      options: {
        label: "pages.blocks.shops-custom-map.initial-position-y.label",
        help: "pages.blocks.shops-custom-map.initial-position-y.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.shops-custom-map.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.shops-custom-map.fieldset.shops.label",
            fields: ["shops"],
          },
          {
            legend: "pages.blocks.shops-custom-map.fieldset.map.label",
            fields: [
              "image",
              "background_color",
              "image_width",
              "image_height",
            ],
          },
          {
            legend: "pages.blocks.shops-custom-map.fieldset.zoom-position.label",
            fields: [
              "initial_zoom",
              "max_zoom",
              "initial_position_x",
              "initial_position_y",
            ],
          },
        ],
      },
    ],
  })
);

export function shopsCustomMapBlockDescriptor(): IBlockDescriptor;
export function shopsCustomMapBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function shopsCustomMapBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedShopsCustomMapBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedShopsCustomMapBlockDescriptor, shopsCustomMapBlockProperties, fieldOrder);
}

export {
  shopsCustomMapBlockBlocDefinition,
  shopsCustomMapBlockDashboardLayout,
  shopsCustomMapBlockProperties,
  shopsCustomMapBlockConfig,
  shopsCustomMapBlockResolveConfig,
};

export type ShopsCustomMapBlockConfig = typeof shopsCustomMapBlockConfig;
